import {
  type Cluster,
  type ClusterStats,
  type Marker,
  type Renderer,
} from '@googlemaps/markerclusterer';

export interface BlazeClusterRendererStyle {
  fillColor: string;
  borderColor: string;
  textColor: string;
}

export class BlazeClusterRenderer implements Renderer {
  constructor(private readonly style: BlazeClusterRendererStyle) {}

  render({ count, position }: Cluster, _stats: ClusterStats, map: google.maps.Map): Marker {
    const html = `
    <div style="width: 60px; height: 60px; display: flex; justify-content: center; align-items: center; pointer-events: none">
      <div style="
        pointer-events: auto;
        border-radius: 9999px;
        font-weight: 500;
        font-size: 14px;
        border: 2px solid ${this.style.borderColor};
        background-color: ${this.style.fillColor};
        display: flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 1);
        color: ${this.style.textColor}
      ">${count}</div>
    </div>
    `;

    const title = `Cluster of ${count} markers`;
    const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
    const parser = new DOMParser();
    const content = parser.parseFromString(html, 'text/html').documentElement.querySelector('div');
    const clusterOptions = {
      map,
      position,
      zIndex,
      title,
      content,
    };
    return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
  }
}
